export default "__VITE_ASSET__1f9e2147__"